export default {
  EDIT_PRODUCT: 'EDIT_PRODUCT',
  EDIT_COMPO: 'EDIT_COMPO',
  EDIT_CPSRA: 'EDIT_CPSRA',
  EDIT_CPSRB: 'EDIT_CPSRB',
};
